module.exports = __webpack_public_path__ + "8471b2a5a526e8ac224ed61932728d52.MP3";